import React from 'react'
import CurrencySymbol from './CurrencySymbol'
import { formatJSON } from '../utils'
import math, { formatNumber } from '../utils/math'

/**
 * 订单商品权益包价格：
 * extendColumn2.couponDetail.coupon_type 2=折扣 3=免费
 * coupon_discount 如 0.7 表示实付 70%
 * 或 packagePrice === 0 视为免费
 */
export const getOrderProductBenefitPriceInfo = (product) => {
  const ext = formatJSON(product?.extendColumn2) || {}
  const detail = ext.couponDetail || ext.coupon_detail || {}
  const couponType = Number(detail.coupon_type ?? detail.couponType ?? 0)
  const packagePrice = product?.packagePrice
  const detailPkg = detail.packagePrice ?? detail.package_price
  const isPackageFree = packagePrice === 0 || packagePrice === '0'
    || (detailPkg != null && detailPkg !== '' && Number(detailPkg) === 0)

  if (couponType === 3 || isPackageFree) {
    const oriAmount = Number(product?.totalPrice)
    return {
      isFree: true,
      amount: 0,
      // 免费不展示划线原价
      oriAmount: Number.isFinite(oriAmount) ? oriAmount : 0
    }
  }

  if (couponType !== 2) return null

  const oriAmount = Number(product?.totalPrice)
  if (!Number.isFinite(oriAmount)) return null

  const discount = Number(detail.coupon_discount ?? detail.couponDiscount)
  if (!Number.isFinite(discount) || discount < 0) return null

  return {
    isFree: false,
    amount: math.mul(oriAmount, discount),
    oriAmount
  }
}

const OrderProductBenefitPrice = ({ product, currencyCode }) => {
  const info = getOrderProductBenefitPriceInfo(product)
  if (!info) {
    return (
      <div className="jm-price">
        <CurrencySymbol currency={currencyCode} />
        {formatNumber(product?.totalPrice)}
      </div>
    )
  }

  return (
    <div className="jm-price" style={{ textAlign: 'right' }}>
      <div>
        <CurrencySymbol currency={currencyCode} />
        {formatNumber(info.amount)}
      </div>
      {!info.isFree && info.oriAmount > info.amount ? (
        <div style={{ color: '#999', fontSize: 12, textDecoration: 'line-through', fontWeight: 400 }}>
          <CurrencySymbol currency={currencyCode} />
          {formatNumber(info.oriAmount)}
        </div>
      ) : null}
    </div>
  )
}

export default OrderProductBenefitPrice
